/**
 * @description [resource入口]
 * @date  2016-05-22
 */
import httpInterceptor from './httpInterceptor'
import dateInterceptor from './dateInterceptor'

export default angular
    .module('app.Factory', [])
    .factory('httpInterceptor', ['$q', httpInterceptor])
    .factory('dateInterceptor', [dateInterceptor])
    .name



// WEBPACK FOOTER //
// ./src/common/factory/index.js